const Headline = (props) => (
  <g fill="#585858" fill-rule="evenodd" {...props}>
    <path d="M.853.532h25v1.5h-25zM28.853.532h11.515v1.5H28.853zM.853 3.532h11.515v1H.853zM14.853 3.532H34.96v1H14.852zM37.853 3.532H57.96v1H37.852z" />
  </g>
)

export default Headline



// WEBPACK FOOTER //
// ./svg/Headline.js